import React from "react";
import ReactPaginate from "react-paginate";
import "./styles/pagination.css"; // Import your custom styles

export function Pagination({ currentPage, totalPages, onPageChange }) {
  const handlePageClick = (data) => {
    onPageChange(data.selected + 1); // react-paginate uses zero-based index
  };

  return (
    <div className="pagination-container">
      <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        pageClassName={"custom-pg-btn"}
        pageLinkClassName={"custom-pg-btn"}
        previousClassName={"custom-pg-btn"}
        previousLinkClassName={"custom-pg-btn"}
        nextClassName={"custom-pg-btn"}
        nextLinkClassName={"custom-pg-btn"}
        activeClassName={"active"}
        disabledClassName={"disabled"}
      />
    </div>
  );
}
